import styled from 'styled-components';

import { Color } from '@pushwoosh/kit-constants';

// Wraps the agreement message (a single polyglot template with embedded <a>
// links) and styles the anchors to match the dumb-components Link.
export const AgreementText = styled.span`
  a {
    color: ${Color.PRIMARY};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${Color.PRIMARY_HOVER};
      text-decoration: underline;
    }

    &:active {
      color: ${Color.PRIMARY_PRESSED};
    }
  }
`;
